import { render } from "./YqIcon.vue?vue&type=template&id=a66e4d3e&scoped=true"
import script from "./YqIcon.vue?vue&type=script&lang=js"
export * from "./YqIcon.vue?vue&type=script&lang=js"

import "./YqIcon.vue?vue&type=style&index=0&id=a66e4d3e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a66e4d3e"],['__file',"src/components/YqIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a66e4d3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a66e4d3e', __exports__)) {
    api.reload('a66e4d3e', __exports__)
  }
  
  module.hot.accept("./YqIcon.vue?vue&type=template&id=a66e4d3e&scoped=true", () => {
    api.rerender('a66e4d3e', render)
  })

}


export default __exports__